/**
 * @generated SignedSource<<0bb397e7276fc4f0f4e444a5c5eb98c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PredefinedVariable",
    "kind": "LinkedField",
    "name": "predefinedVariables",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QPredefinedVariablesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "QPredefinedVariablesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7573da8736308f06ddf20d644e07e035",
    "id": null,
    "metadata": {},
    "name": "QPredefinedVariablesQuery",
    "operationKind": "query",
    "text": "query QPredefinedVariablesQuery {\n  predefinedVariables {\n    key\n    description\n  }\n}\n"
  }
};
})();

node.hash = "840fc26b4c3e2c75778b1f5134efdc86";

export default node;
